import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { IdBadgePosition } from "./IdBadgePosition";
import { mapBadgePositionTranslateMultiplier } from "./mapBadgePositionTranslateMultiplier";
export var Badge = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.position, position = _c === void 0 ? IdBadgePosition.TopRight : _c, children = _a.children;
    // tslint:disable-next-line:no-null-keyword
    var ref = useRef(null);
    var _d = useState(true), fetchData = _d[0], setFetchData = _d[1];
    var _e = useState({}), translateStyle = _e[0], setTranslateStyle = _e[1];
    useEffect(function () {
        if (ref && ref.current) {
            var elementHeight = ref.current.clientHeight;
            var elementWidth = ref.current.clientWidth;
            var _a = mapBadgePositionTranslateMultiplier[position], multiplierLeft = _a[0], multiplierTop = _a[1];
            var translateTop = Math.floor(elementHeight * multiplierTop);
            var translateLeft = Math.floor(elementWidth * multiplierLeft);
            setTranslateStyle({
                transform: "translate(" + translateLeft + "px, " + translateTop + "px",
            });
        }
        setFetchData(false);
    }, [fetchData]);
    return (React.createElement("div", { style: translateStyle, ref: ref, className: "badge " + position + " " + className }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/badge/Badge.tsx
// module id = 47
// module chunks = 3